import React, { Component, Fragment } from 'react';
import { Paper, TablePagination, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox } from '@material-ui/core';
import { Alert } from '@material-ui/lab';


class SelectContentSearchTable extends Component {

    state = {
        searchResultListEvents: {},
        dataSelectContent: {
            selectListEvents: [],
            errors: {
                selectListEvents: false
            }
        },
        pageNumberEventList: 1,
        pageSizeEventList: 10,
        backoffficeUrl: ""
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            searchResultListEvents: nextProps.searchResultListEvents,
            dataSelectContent: nextProps.dataSelectContent,
            pageNumberEventList: nextProps.pageNumberEventList, 
            pageSizeEventList: nextProps.pageSizeEventList,
            backoffficeUrl: nextProps.backoffficeUrl
        });
    }

    onChangePage = (e, newPage) => {
        this.props.onChangePage(newPage)
    };

    handleChangeCheckbox = (e, check) => {
        let dataSelectContent = this.state.dataSelectContent;
        if (check) {
            dataSelectContent.selectListEvents.push({ id: e.target.value });
        } else {
            dataSelectContent.selectListEvents = dataSelectContent.selectListEvents.filter(item => item.id !== e.target.value);
        }
        dataSelectContent.errors.selectListEvents = true;
        if (dataSelectContent.selectListEvents.length > 0) {
            dataSelectContent.errors.selectListEvents = false;
        }
        this.setState({ dataSelectContent: dataSelectContent });
        this.props.onChangeSelectList(dataSelectContent);
    };

    render() {
        let errroSelectList = this.state.dataSelectContent.errors.selectListEvents;
        let countRows = -1;
        let TextInitial = "Select the keyword you want to search";
        let TextNoFound = "Sorry, no matching records found";
        let TextError = "Sorry, select at least event";
        let rows;
        if (Object.keys(this.state.searchResultListEvents).length > 0) {
            countRows = this.state.searchResultListEvents.totalCount;
            rows = this.state.searchResultListEvents.data.map((item, index) =>
                <TableRow key={index}>
                    <TableCell align="center" padding="checkbox">
                        <Checkbox
                            checked={(this.state.dataSelectContent.selectListEvents.some(itemSelect => String(item.IDEVENT) === String(itemSelect.id))) ? true : false}
                            value={item.IDEVENT}
                            onChange={this.handleChangeCheckbox}
                            with={25}
                        />
                    </TableCell>
                    <TableCell align="left"><a href={this.state.backoffficeUrl + "/Event_Modify.asp?code=" + item.IDEVENT} target="_blank" rel="noopener noreferrer">{item.TITLE}</a></TableCell>
                </TableRow>
            );
        }
        return (
            <Fragment>
                <Fragment>
                    <TableContainer component={Paper}>
                        <Table
                            aria-labelledby="tableTitle"
                            size='small'
                            aria-label="enhanced table">
                            <TableBody>
                                {
                                    (countRows > 0) && rows
                                }
                            </TableBody>
                            {
                                (countRows === -1 && errroSelectList === false) &&
                                < caption >
                                    <Alert severity="info"> {TextInitial}</Alert>
                                </caption>
                            }
                            {
                                (countRows === 0) &&
                                < caption >
                                    <Alert severity="info"> {TextNoFound}</Alert>
                                </caption>
                            }
                            {
                                (errroSelectList === true) &&
                                < caption >
                                    <Alert severity="error"> {TextError}</Alert>
                                </caption>
                            }
                        </Table>
                    </TableContainer>
                    {
                        (countRows > 0) && <TablePagination
                            rowsPerPageOptions={[10]}
                            count={countRows}
                            rowsPerPage={this.state.pageSizeEventList}
                            page={this.state.pageNumberEventList - 1}
                            component="div"
                            onChangePage={this.onChangePage}
                        />
                    }
                </Fragment>
            </Fragment >
        )  
    }
};

export default SelectContentSearchTable;